import React from "react";
import ReactDOM from "react-dom";
import { PropTypes } from "prop-types";
import { InfiniteStoryBase, SocialShare, WithHostUrl, Link } from "@quintype/components";
import { get } from "lodash";
import { connect } from "react-redux";
import TextStoryHeader from "./story-templates/shared/text-story-header";
import StoryHeader from "./story-templates/shared/story-header";
import StoryLock from "../../atoms/story-lock";
import { STORY_TEMPLATES } from "../../../constants";
import { TextStory } from "./story-templates/text-story-page";
import { PhotoAlbumStory } from "./story-templates/photo-album-story";
import { VideoStory } from "./story-templates/video";
import { PhotoStory } from "./story-templates/photo";
import { ListicleStory } from "./story-templates/listicle-story";
import { LongFormStory } from "./story-templates/long-form";
import { ReviewStory } from "./story-templates/review";
import { LiveBlogStory } from "./story-templates/live-blog";
import { SocialShareTemplate } from "./story-templates/shared/social-share";
import Tags from "./story-templates/shared/tags";
import AuthorDetail from "./story-templates/shared/author-detail";
import Metype from "./story-templates/shared/metype";
import Vuukle from "./story-templates/shared/vuukle";
import { generateHostStoryUrl } from "../../utils/generate-story-url";
import { DfpAd } from "../../atoms/dfp-ad";
import RelatedStories from "./story-templates/shared/related-stories";
import {
  fetchLatestStories,
  fetchRelatedStories,
  fetchStoryAttributes,
  fetchCollection,
  triggerwruEvent
} from "../../../api";
import { hasStoryAccess, incrementPremiumStoriesRead } from "../../../paywall";
import { GA, WebEngage, LoadVuukle } from "../../../integrations";

import ErrorBoundary from "../../utils/error-boundary";
import { isPremium } from "../../../data/story";
import SecondaryMenu from "../../atoms/secondary-menu";
import { Icon } from "../../atoms/icon";
import Cookies from "universal-cookie";

import styles from "./styles.m.css";
import { removeBulletImagesFromStory } from "../../utils/utils";
const cookies = new Cookies();
function getStoryTemplateComponent(storyTemplate) {
  switch (storyTemplate) {
    case STORY_TEMPLATES.VIDEO:
      return VideoStory;
    case STORY_TEMPLATES.PHOTO:
      return PhotoStory;
    case STORY_TEMPLATES.PHOTO_ALBUM:
      return PhotoAlbumStory;
    case STORY_TEMPLATES.REVIEW:
      return ReviewStory;
    case STORY_TEMPLATES.LISTICLE:
      return ListicleStory;
    case STORY_TEMPLATES.LIVE_BLOG:
      return LiveBlogStory;
    case STORY_TEMPLATES.LONG_FORM:
      return LongFormStory;
    default:
      return TextStory;
  }
}

function appendCustomQueryStringUrl(story) {
  const url = story.slug;
  const [baseUrl, queryParams] = url.split("?");
  const regExp = new RegExp(/artfrm=infinite/);
  if (queryParams && regExp.test(queryParams)) {
    return story;
  }
  story.slug = `${baseUrl}?artfrm=infinite`;
  return story;
}

function storyPageFetchRelatedItems(currentHostUrl, story, cinemaMode) {
  return fetchRelatedStories(story).then(stories =>
    stories.filter(story => (cinemaMode ? story.url.startsWith(currentHostUrl) : true))
  );
}

class StoryTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relatedStories: [],
      access: null,
      socialView: false
    };
    this.floatingbar = React.createRef();
    this.handleClickView = this.handleClickView.bind(this);
  }

  componentDidMount() {
    if (typeof this.props.fetchRelatedStories === "function") {
      this.props
        .fetchRelatedStories(this.props.story)
        .then(relatedStories => {
          this.setState({ relatedStories });
        })
        .catch(console.error);
    }

    hasStoryAccess(this.props.story)
      .then(access => {
        this.setState({ access: access });
      })
      .catch(console.error);
  }

  handleClickView() {
    window.scrollTo({
      top: this.floatingbar.current.offsetTop - 120,
      behavior: "smooth"
    });
  }

  handleClickEvents(args) {
    GA.customEvent("Share Click", args, this.props.story.id);
  }

  render() {
    const story = removeBulletImagesFromStory(get(this.props, ["story"], null));
    if (!story) {
      return null;
    }
    const metypeConfig = get(this.props, ["metypeConfig"]);
    const config = get(this.props, ["config"]);
    const episodes = get(this.props, ["episodes"]);

    const renderSocialMedia = (className = "") => (
      <SocialShare
        className={className}
        template={SocialShareTemplate}
        fullUrl={story.url}
        title={story.headline}
        handleClickView={this.handleClickView}
        hashtags={
          story.tags &&
          story.tags
            .filter(tag => tag !== null)
            .map(tag => tag.name)
            .toString()
        }
        storyId={story.id}
      />
    );

    const renderHeaderCard = ({ className } = { className: "" }) => (
      <StoryHeader
        // renderSocialMedia={renderSocialMedia}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
      />
    );

    const renderTextStoryHeaderCard = ({ className } = { className: "" }) => (
      <TextStoryHeader
        // renderSocialMedia={renderSocialMedia}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
      />
    );

    const renderTags = () => <Tags tags={story.tags} className={styles.tags} />;

    const renderAuthorDetails = () => (
      <AuthorDetail
        authors={story.authors}
        config={config}
        contributors={story.contributors}
        className={styles["author-detail"]}
      />
    );

    const renderReactions = () => {
      if (!metypeConfig) {
        return null;
      }
      return (
        <ErrorBoundary>
          <Metype id={story.id} metypeConfig={metypeConfig} type={"reaction"} pageURL={generateHostStoryUrl(story)} />
        </ErrorBoundary>
      );
    };

    const renderVuukleComments = () => {
      return <Vuukle story={story} vuukleConfig={this.props.config.vikatanHosts} />;
    };

    const renderComments = () => {
      if (!metypeConfig) {
        return null;
      }
      return (
        <Metype id={story.id} type={"comment"} metypeConfig={metypeConfig} pageURL={generateHostStoryUrl(story)} />
      );
    };

    const renderRelatedStories = (cssClassName = "") => (
      <RelatedStories
        className={`${styles["related-stories"]} js-related-stories ${cssClassName}`}
        collection={{
          name: "லேட்டஸ்ட் செய்திகள் உங்களுக்காக",
          items: this.state.relatedStories.map(story => {
            return { story };
          })
        }}
      />
    );

    const renderSidebar = () => (
      <aside className={styles.sidebar}>
        {!isPremium(this.props.story) && (
          <div className={`${styles["ad-wrapper"]} hidden-mobile`}>
            <DfpAd story={story} adtype="Rectangle" placement="story" />
          </div>
        )}

        {!isPremium(this.props.story) && (
          <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
            <DfpAd story={story} adtype="Half_Page" placement="story" />
          </div>
        )}
      </aside>
    );

    const renderFooter = () => (
      <div className="js-story-footer">
        {!isPremium(this.props.story)}
        {(["METERING", "METERING LOCAL"].includes(get(this.state, ["access", "grantReason"])) ||
          (this.state.access && !get(this.state, ["access", "granted"]))) && (
          <StoryLock access={this.state.access} collectionId={get(this.props, ["issueCollection", "id"])} />
        )}
        {renderTags()}
        {!isPremium(this.props.story) && <DfpAd story={story} adtype="Small_Leaderboard" placement="story" />}
        <div ref={this.floatingbar}>{renderVuukleComments()}</div>
        {renderAuthorDetails()}
        <div className={styles["space-before-next-story"]} />
      </div>
    );

    const renderfloatingBar = () => (
      <React.Fragment>
        <div className={"social-icons-div hidden-desktop"}>
          <div className="share-mb-div">
            <ul className={"mb-share"}>
              <li className="newsletter" onClick={this.handleClickView}>
                <a href="javascript:" onClick={this.handleClickEvents.bind(this, "comments")}>
                  <Icon type="newsletter" />
                </a>
              </li>
              <li className="share whatsapp">{renderSocialMedia()}</li>
              <li className="share" onClick={() => this.setState({ socialView: !this.state.socialView })}>
                <a href="JavaScript:">
                  {!this.state.socialView ? <Icon type="socialshare" /> : <Icon type="cancel" />}
                </a>
              </li>
            </ul>
          </div>
          {this.state.socialView && renderSocialMedia("show-mobile-and-tablet story-section")}
        </div>
      </React.Fragment>
    );

    const renderProps = {
      renderSocialMedia,
      renderTags,
      renderAuthorDetails,
      renderReactions,
      renderComments,
      renderSidebar,
      renderHeaderCard,
      renderTextStoryHeaderCard,
      renderFooter,
      renderRelatedStories,
      renderfloatingBar
    };

    const StoryTemplateComponent = getStoryTemplateComponent(story["story-template"]);

    return (
      <React.Fragment>
        <StoryTemplateComponent
          story={{
            ...story,
            cards: isPremium(story) && !get(this.state, ["access", "granted"], false) ? [] : story.cards
          }}
          config={config}
          episodes={episodes}
          {...renderProps}
          fireVirtualPageView={this.props.firePageView}
        />
        {!get(this.props.config, ["disableAds"]) && (
          <div className="container">
            {!isPremium(this.props.story) && <DfpAd adtype="Large_Leaderboard" placement="story" />}
            {!isPremium(this.props.story)}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export class StoryPageBase extends React.Component {
  render() {
    const { story, fetchRelatedStories, episodes, config, metypeConfig, firePageView, issueCollection } = this.props;
    return (
      <div className={`js-content-insights-${story.id}`}>
        <StoryTemplate
          story={story}
          config={config}
          fetchRelatedStories={fetchRelatedStories}
          episodes={episodes}
          metypeConfig={metypeConfig}
          firePageView={firePageView}
          issueCollection={issueCollection}
        />
      </div>
    );
  }
}
StoryPageBase.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: TextStory.propTypes.story,
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  fetchRelatedStories: PropTypes.func,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  })
};
class WrapperStoryIntersectionObserverBase extends React.Component {
  constructor(props) {
    super(props);
    this.storyRef = React.createRef();
  }

  componentDidMount() {
    this.intersectionObserver =
      global.IntersectionObserver &&
      new global.IntersectionObserver(
        entries => {
          // There will be only One target as we are implementing one Intersection Observer for every Story
          const story = this.props.story;
          if (entries[0].isIntersecting === true) {
            if (isPremium(story)) {
              hasStoryAccess(story).then(access => {
                if (access.granted && (access.grantReason === "METERING" || access.grantReason === "METERING LOCAL")) {
                  incrementPremiumStoriesRead(story.id);
                }
                access.remainingStoriesCount >= 0 &&
                  this.props.updateRemainingStoriesCounter(access.remainingStoriesCount);
              });
            }
            this.intersectionObserver && this.intersectionObserver.disconnect();
          }
        },
        {
          rootMargin: "0px"
        }
      );
    /* eslint-disable react/no-find-dom-node */
    this.intersectionObserver.observe(ReactDOM.findDOMNode(this.storyRef.current));
  }
  componentWillUnmount() {
    this.intersectionObserver && this.intersectionObserver.disconnect();
  }
  render() {
    return <StoryPageBase {...this.props} ref={this.storyRef} />;
  }
}
// Dispatch the action to update the store from the Intersection Observer
const mapDispatchToProps = dispatch => {
  return {
    updateRemainingStoriesCounter: function(remainingStoriesCount) {
      dispatch({
        type: "UPDATE_STORIES_READ_STATS",
        remainingStoriesCount: remainingStoriesCount
      });
    }
  };
};
const WrapperStoryIntersectionObserver = connect(
  state => state,
  mapDispatchToProps
)(WrapperStoryIntersectionObserverBase);

const getStoriesByLabel = collection => {
  return collection.items.filter(({ story = {} }) => story.headline && story.url).reduce((storyMap, item) => {
    const label = get(item, ["associated-metadata", "label"], "மற்றவை");
    if (storyMap[label]) {
      storyMap[label].push(item.story);
    } else {
      storyMap[label] = [item.story];
    }
    return storyMap;
  }, {});
};

const generateSecondaryMenu = (issueCollection, magazine) => {
  const storyMap = issueCollection && getStoriesByLabel(issueCollection);
  const rootMenuGroup = Object.keys(storyMap).map((label, idx) => {
    return {
      title: label,
      id: idx,
      items: storyMap[label].map(storyObject => {
        return {
          title: storyObject["headline"],
          url: storyObject["url"]
        };
      })
    };
  });

  const firstElement = magazine.name && (
    <Link href={issueCollection.pagePath} className={styles["magazine-name"]}>
      {magazine.name.replace(/\(\w+\)/, "")}
    </Link>
  );
  const root = {
    items: rootMenuGroup
  };
  return (
    <SecondaryMenu
      menuGroup={root}
      className={styles["magazine-secondary"]}
      firstElement={firstElement}
      communityColor={magazine.color}
    />
  );
};

export class StoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.firePageView = this.firePageView.bind(this);
    this.cachedFirstPageStories = [];
    this.MAX_ALREADY_STORIES_READ_COUNT = 20;
  }

  isStoryNotReadYet(storyId) {
    if (!global.localStorage) {
      return true;
    }

    const alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    return !alreadyReadStories.includes(storyId);
  }

  markStoryAsRead(storyId) {
    if (!global.localStorage) {
      return null;
    }
    let alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    if (alreadyReadStories.length >= this.MAX_ALREADY_STORIES_READ_COUNT) {
      alreadyReadStories = [];
    }
    let alreadyReadStoriesSet = new Set(alreadyReadStories);
    alreadyReadStoriesSet.add(storyId);
    global.localStorage.setItem("alreadyReadStories", JSON.stringify(Array.from(alreadyReadStoriesSet)));
  }

  storyPageLoadItems(currentHostUrl, pageNumber, collectionMapping) {
    const subDomain = currentHostUrl.replace(/(http:\/\/|https:\/\/)/i, "").split(".")[0];
    const collectionSlug = collectionMapping[subDomain];
    const NUMBER_OF_STORIES_PER_PAGE = 3;
    let limit =
      this.MAX_ALREADY_STORIES_READ_COUNT / NUMBER_OF_STORIES_PER_PAGE > pageNumber + 1
        ? this.MAX_ALREADY_STORIES_READ_COUNT
        : 3;

    let storiesPromise = Promise.resolve(this.cachedFirstPageStories);
    if (
      !this.cachedFirstPageStories.length ||
      this.MAX_ALREADY_STORIES_READ_COUNT / NUMBER_OF_STORIES_PER_PAGE < pageNumber + 1
    ) {
      if (collectionSlug) {
        storiesPromise = fetchCollection(collectionSlug, pageNumber, limit, {}).then(response => {
          return this.collectioshema(response["items"]);
        });
      } else {
        storiesPromise = fetchLatestStories(pageNumber, limit).then(response => {
          return response.stories ? response.stories.map(story => ({ story: appendCustomQueryStringUrl(story) })) : [];
        });
      }
    }

    return storiesPromise.then(stories => {
      this.cachedFirstPageStories = stories;
      const storiesAfterFiltering = stories.filter(({ story }) => this.isStoryNotReadYet(story.id));
      if (!storiesAfterFiltering.length) {
        return stories.slice(0, NUMBER_OF_STORIES_PER_PAGE);
      }

      return storiesAfterFiltering.slice(0, NUMBER_OF_STORIES_PER_PAGE);
    });
  }

  collectioshema = stories => {
    return stories
      ? stories.map(data => ({
          story: appendCustomQueryStringUrl(data.story),
          id: data.id,
          score: data.score,
          type: data.type,
          item: data.item
        }))
      : [];
  };

  componentDidMount() {
    const story = get(this.props, ["data", "story"], {});
    this.markStoryAsRead(story.id);
    this.firePageView();
  }

  firePageView(story = this.props.data.story, firedFromInfinite = false) {
    if (this.props.config.disableAds) {
      return;
    }
    LoadVuukle.register(story, this.props.config.vikatanHosts);
    const issueCollection = get(this.props, ["data", "issueCollection"], null);

    WebEngage.registerPageView({ story });
    global.userPromise.catch(() => null).then(user => {
      triggerwruEvent(story.id, cookies.get("thinmint"), "STORY_VIEW_EVENT", user);
    });
    fetchStoryAttributes(story)
      .then(result => {
        GA.registerPageView(this.props.pageType, {
          story: { ...story, collections: result.collections },
          collection: issueCollection,
          infiniteTagRequired: firedFromInfinite
        });
      })
      .catch(console.error);
  }

  sendQlitics = (story = {}) => {
    const { registerStoryView } = require("@quintype/framework/client/analytics");
    registerStoryView(story.id);
  };

  render() {
    const metypeConfig = get(this.props, ["data", "publisherConfig", "metypeConfig"]);
    const collectionMapping = get(this.props, ["config", "collectionMapping"], null);
    const issueCollection = get(this.props, ["data", "issueCollection"]);
    const magazineEntity = get(this.props, ["data", "magazineEntity"]);
    const cinemaMode = get(this.props, ["config", "cinemaMode"]);
    return (
      <React.Fragment>
        {issueCollection &&
          magazineEntity && (
            <div className={styles["secondary-menu"]}>{generateSecondaryMenu(issueCollection, magazineEntity)}</div>
          )}

        <WithHostUrl>
          {({ currentHostUrl }) => (
            <InfiniteStoryBase
              {...this.props}
              render={storyProps => (
                <WrapperStoryIntersectionObserver
                  {...Object.assign({}, storyProps)}
                  config={this.props.config}
                  metypeConfig={metypeConfig}
                  fetchRelatedStories={story => storyPageFetchRelatedItems(currentHostUrl, story, cinemaMode)}
                  firePageView={() => this.firePageView(storyProps.story)}
                />
              )}
              loadItems={pageNumber => this.storyPageLoadItems(currentHostUrl, pageNumber, collectionMapping)}
              onInitialItemFocus={item => {
                if (item.story && item.story.id) {
                  this.markStoryAsRead(item.story.id);
                  this.sendQlitics(item.story);
                  this.firePageView(item.story, true);
                }
              }}
              onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
              neverHideItem={true}
            />
          )}
        </WithHostUrl>
        {!isPremium(this.props.story) && (
          <DfpAd story={this.props.story} adtype="Inarticle_fork_cinema" placement="story" />
        )}
        {!isPremium(this.props.story) && (
          <DfpAd story={this.props.story} className="hidden-desktop" adtype="Sticker_mcanvas" placement="story" />
        )}
      </React.Fragment>
    );
  }
}
